import styled from 'styled-components';
import { space, layout, color } from 'styled-system';
import { StyledProps } from 'types/styles';

interface Props extends StyledProps {
  cursor?: string;
}

export const Wrapper = styled.div<Props>`
  display: flex;
  cursor: ${({ cursor }) => (cursor ? cursor : 'default')};

  ${color}
  ${space}
  svg {
    ${layout}
  }
`;
